// Estilo alimentar. Mesmo widget das restrições, com "Nenhuma em especial"
// como exclusivo. Payload de sempre: PREFERENCIA_ALIMENTAR (boolean) +
// PREFERENCIA_ALIMENTAR_DETAILS (texto).

import React from "react";

import ChipsComOutro from "./ChipsComOutro.jsx";

const OPCOES = [
  { value: "nenhuma", label: "Nenhuma em especial" },
  { value: "vegetariana", label: "Vegetariana" },
  { value: "vegana", label: "Vegana" },
  { value: "low_carb", label: "Low-carb" },
  { value: "cetogenica", label: "Cetogênica" },
  { value: "mediterranea", label: "Mediterrânea" },
  { value: "jejum", label: "Jejum intermitente" },
];

const StepPrefAlimentares = (props) => (
  <ChipsComOutro
    {...props}
    opcoes={OPCOES}
    exclusivo="nenhuma"
    placeholder="Ex.: como pouca carne, prefiro comida japonesa…"
    chaveBool="PREFERENCIA_ALIMENTAR"
    chaveTexto="PREFERENCIA_ALIMENTAR_DETAILS"
  />
);

export default StepPrefAlimentares;
